module.exports = __webpack_public_path__ + "img/mont-chamber.0376d95e.jpg";